import appConstants from "../../../../appConstants";
import { formatAddress } from "../../Dispatch/utils/utils";
import { isPickupStop } from "../../IBPlanning/Common/MergeStops/utills";
const getNoFMEOptions = (isNoFME = true) => [
  {
    name: "isNoFME",
    labelText: "Not an FME Customer",
    isChecked: isNoFME,
    disabled: false,
  },
];

const getDeliveryAccessorialList = ({
  featureFlags,
  isLiftGateRequired = false,
  isTrailerDrop = false,
  isNoLg = false,
  isLocal = false,
}) => [
  {
    name: "isLiftGateRequired",
    labelText: "Requires LG",
    isChecked: isLiftGateRequired,
    disabled: false,
  },
  ...(featureFlags.enableNonLGCustomer ? [
    {
      name: "isNoLg",
      labelText: "Not a LG Customer",
      isChecked: isNoLg,
      disabled: false,
    },
  ]: []),
  {
    name: "isTrailerDrop",
    labelText: "Trailer Drop",
    isChecked: isTrailerDrop,
    disabled: false,
  },
  {
    name: "isLocal",
    labelText: "Local Customer",
    isChecked: isLocal,
    disabled: false,
  },
];

const getPickupAccessorialList = ({
  featureFlags,
  isLiftGateRequired = false,
  isTrailerSwap = false,
  isNoLg = false,
  isLocal = false,
}) => [
  {
    name: "isLiftGateRequired",
    labelText: "Requires LG",
    isChecked: isLiftGateRequired,
    disabled: false,
  },
  ...(featureFlags.enableNonLGCustomer ? [
    {
      name: "isNoLg",
      labelText: "Not a LG Shipper",
      isChecked: isNoLg,
      disabled: false,
    },
  ]: []),
  {
    name: "isTrailerSwap",
    labelText: "Trailer Swap",
    isChecked: isTrailerSwap,
    disabled: false,
  },
  {
    name: "isLocal",
    labelText: "Local Shipper",
    isChecked: isLocal,
    disabled: false,
  },
];

const getDefaultErrorInfo = () => {
  return {
    receivingHours: {
      monday: [],
      tuesday: [],
      wednesday: [],
      thursday: [],
      friday: [],
    },
    defaultHours: "",
    noFMECustomer: "",
  };
};

const getNoFMECustomerErrorInfo = ({
  noFMECustomerOptions,
  maxEquipmentSize,
}) => {
  /* Condition for SEFL to not allow update:
    1. maxEquipmentSize=appConstants.FME_ROUTE_TRAILER_LENGTH,
    2. No FME Customer checkbox selected
  */
  return noFMECustomerOptions &&
    maxEquipmentSize === appConstants.FME_ROUTE_TRAILER_LENGTH
    ? `Max Equip Size can't be ${appConstants.FME_ROUTE_TRAILER_LENGTH} for non-FME customers`
    : null;
};

const isDeliveryTab = (activeTab) => {
  return activeTab === appConstants.CUSTOMER_TYPE.DELIVERY;
};

const getFormInputValues = (formData) => {
  if (isDeliveryTab(formData.activeTab)) {
    return {
      defaultHours: formData.deliveryDetails.defaultHours,
      receivingHours: formData.receivingHours,
      errorInfo: formData.deliveryDetails.errorInfo,
      stopTime: formData.deliveryDetails.stopTime,
      appointmentBufferStart: formData.deliveryDetails.appointmentBufferStart,
      appointmentBufferEnd: formData.deliveryDetails.appointmentBufferEnd,
      maxDelay: formData.deliveryDetails.maxDelay,
      moveablePalletCount: formData.deliveryDetails.moveablePalletCount
    };
  }
  return {
    defaultHours: formData.pickupDetails.defaultHours,
    receivingHours: formData.pickupDetails.shippingHours,
    errorInfo: formData.pickupDetails.errorInfo,
    stopTime: formData.pickupDetails.stopTime,
    appointmentBufferStart: formData.pickupDetails.appointmentBufferStart,
    appointmentBufferEnd: formData.pickupDetails.appointmentBufferEnd,
    maxDelay: formData.pickupDetails.maxDelay,
    moveablePalletCount: formData.pickupDetails.moveablePalletCount
  };
};

const getDefaultHours = (params) => {
  const fieldName =
  params.api.gridName === appConstants.gridNames.CustomerGrid
  ? "deliveryDetails"
  : "pickupDetails";
  const { openHours = "", closeHours = "" } = params.data[fieldName] ?? {};
  if (openHours && closeHours) {
    return `${openHours} - ${closeHours}`;
  }
  return "";
};

const formatDayWindow = (params) => {
  if (params.value?.length === 1 && params.value[0] === "00:00 - 00:00") {
    return "Closed";
  }
  return params.value?.join(",");
};

const renderWindow = (params) => {
  let style = {}
  if(params.valueFormatted === "Closed"){
     style = {opacity:0.7, fontStyle:"italic"}
  }
  return <div style={style}>{params.valueFormatted}</div>;
}

const getCustomerDataByStopType = (customerData, stopType) => {
  const {
    name = "",
    address = "",
    address2 = "",
    city = "",
    state = "",
    zip = "",
  } = customerData;
  const stopTypeFieldId = isPickupStop(stopType)
    ? "pickupDetails"
    : "deliveryDetails";
  const {
    openHours = "",
    closeHours = "",
    routeName = "",
    specialInstruction = "",
  } = customerData[stopTypeFieldId];
  const combinedAddress = formatAddress({
    address: `${address} ${address2}`.trim(),
    city,
    state,
    zip,
  });
  return {
    address: combinedAddress,
    name,
    openHours,
    closeHours,
    routeName,
    specialInstruction,
  };
};

export {
  getNoFMEOptions,
  getDeliveryAccessorialList,
  getPickupAccessorialList,
  getDefaultErrorInfo,
  getNoFMECustomerErrorInfo,
  isDeliveryTab,
  getFormInputValues,
  getDefaultHours,
  formatDayWindow,
  renderWindow,
  getCustomerDataByStopType,
};
